import AppProvider from '@Core/Provider'
import { RouterProvider } from 'react-router-dom'
import React, { useEffect } from 'react'
import { MathJaxContext } from 'better-react-mathjax'

import { appRouter } from './config'
import Page403 from './CommonPage/ErrorPage/pages/Page403'
import PageMaintain from './CommonPage/ErrorPage/pages/PageMaintain'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { getQueryUrlObject } from '@Core/Helpers/Url'
import { SESSION_STORAGE, setDataSession } from '@Core/Helpers/Session'
import { Analytics } from '@vercel/analytics/react'
const maintain = false

const App = props => {
	useEffect(() => {
		const query = getQueryUrlObject()
		if (query?.super_admin) {
			setDataSession(SESSION_STORAGE, 'super_admin', 1)
		}
		window.addEventListener('vite:preloadError', event => {
			window.location.reload() // for example, refresh the page
		})
	}, [])

	if (maintain) {
		return (
			<div className="flex flex-col items-center justify-center min-h-screen">
				<PageMaintain />
			</div>
		)
	}

	return (
		<AppProvider>
			<MathJaxContext>
				<RouterProvider router={appRouter} />
			</MathJaxContext>
			<Analytics />
		</AppProvider>
	)
}

export default App
